import { PRIVATE_EVENT_ADD_ONS } from '../../../api/privateEvents';
import { fieldStyle, TogglePill } from '../../dashboards/primitives';
import { ControlBlock } from '../../dashboards/primitives/ControlBlock';
import { PriceInput } from '../../dashboards/primitives/PriceInput';
import { Field } from '../../dashboards/venues/venueCreateFields';
import type { PrivateEventForm } from '../usePrivateEventForm';

import { COLUMN, NOTE } from './step-layout';

/** Step 3: the reference deal value, the HubSpot link, the add-ons and notes. */
export default function CommercialsStep({ form }: { form: PrivateEventForm }) {
  const { fields, set, toggleAddOn, fieldError } = form;
  return (
    <div style={COLUMN}>
      <Field label="Deal value" error={fieldError('dealValueCents')}>
        <PriceInput
          ariaLabel="Deal value"
          value={fields.dealValue}
          error={fieldError('dealValueCents')}
          onChange={(v) => set('dealValue', v)}
        />
      </Field>
      <p style={NOTE}>A reference figure. Nebari takes no payment for private events.</p>
      <Field label="HubSpot deal" error={fieldError('hubspotDealId')}>
        <input
          aria-label="HubSpot deal"
          value={fields.hubspotDealId}
          onChange={(e) => set('hubspotDealId', e.target.value.replace(/^.*\/deal\//, ''))}
          placeholder="e.g. 9271884402"
          style={fieldStyle(undefined)}
        />
      </Field>
      <ControlBlock label="Add-ons" required={false}>
        <div
          role="group"
          aria-label="Add-ons"
          style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}
        >
          {PRIVATE_EVENT_ADD_ONS.map((a) => (
            <TogglePill
              key={a.id}
              selected={fields.addOns.includes(a.id)}
              onClick={() => toggleAddOn(a.id)}
            >
              {a.label}
            </TogglePill>
          ))}
        </div>
      </ControlBlock>
      <Field label="Notes" error={fieldError('notes')}>
        <textarea
          aria-label="Notes"
          value={fields.notes}
          onChange={(e) => set('notes', e.target.value)}
          rows={3}
          style={fieldStyle(undefined, { height: 'auto', padding: '8px 10px', resize: 'vertical' })}
        />
      </Field>
    </div>
  );
}
